(function () {
  'use strict';

  var SCHEMA_VERSION = '1.0';
  var seen = new Set();
  var OPTIONAL_PARAMETERS = [
    'source_component',
    'component_action',
    'interaction_location',
    'display_mode',
    'destination_type',
    'quiz_variant',
    'quiz_step',
    'quiz_step_total',
    'item_id',
    'item_name',
    'item_count',
    'quantity',
    'article_handle'
  ];

  function pageTemplate() {
    var main = document.querySelector('main[data-template]');
    return main ? String(main.getAttribute('data-template') || '') : '';
  }

  function clean(value) {
    if (value === undefined || value === null || value === '') return undefined;
    return value;
  }

  function push(eventName, parameters) {
    if (!eventName) return;
    window.dataLayer = window.dataLayer || [];

    var payload = {
      event: String(eventName),
      measurement_schema_version: SCHEMA_VERSION,
      site_code: 'bsn',
      page_template: pageTemplate()
    };

    // GTM data-layer values persist between pushes. Explicitly clear optional
    // parameters so an item or quiz value cannot leak into the next event.
    OPTIONAL_PARAMETERS.forEach(function (key) {
      payload[key] = null;
    });

    Object.keys(parameters || {}).forEach(function (key) {
      var value = clean(parameters[key]);
      if (value !== undefined) payload[key] = value;
    });

    window.dataLayer.push(payload);
  }

  function once(key, callback) {
    if (!key || seen.has(key)) return false;
    seen.add(key);
    callback();
    return true;
  }

  function componentView(sourceComponent, parameters, key) {
    var onceKey = key || ['view', sourceComponent, pageTemplate()].join(':');
    return once(onceKey, function () {
      push('component_view', Object.assign({ source_component: sourceComponent }, parameters || {}));
    });
  }

  function componentInteraction(sourceComponent, componentAction, parameters) {
    push('component_interaction', Object.assign({
      source_component: sourceComponent,
      component_action: componentAction
    }, parameters || {}));
  }

  function toolEvent(eventName, sourceComponent, parameters) {
    push(eventName, Object.assign({ source_component: sourceComponent }, parameters || {}));
  }

  window.BSNMeasurement = {
    schemaVersion: SCHEMA_VERSION,
    push: push,
    once: once,
    componentView: componentView,
    componentInteraction: componentInteraction,
    toolEvent: toolEvent
  };
}());
